// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import api from '../../../../../common/api';
import handler from '../../../../../share/util/apiResultValidator';
import individualDiagnose from '../../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import config from '../../../../../share/config';
import session from '../../../../../share/session';
import customTable from '../../../../../share/components/vue/PaginationTable';
import projectData from '../../../../../share/components/vue/ProjectData';
import util from '../../../../../share/util/utils';
import diagnoseResource from "../../../../../share/util/diagnose";
import shareVehicle from '../../../../../share/util/vehicle';
import fileExport from "../../../../../util/fileExport";
import vinInfoUtils from "../../../../../util/vinInfoUtils";

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  LIST_VIEW: 'listView',
  NODATA: 'nodata',
  DETAILED_FD: 'detailedFd',
  PROJECT_DATA: 'projectData',
  FAILED: 'failed',
};

export default {
  name: 'requirementSpES7',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      systemId: '',
      displayInfo: [],          // 一覧表示用変数
      tableColumns: [],
      displayFdInfo: [],        // FFD詳細表示用変数
      tableFdColumns: [],
      // データ保持用
      preFdData: {},
      preDetailFdData: {},
      statusValue: '',                                                          // 詳細FDに表示するステータス
      statusLabel: '',                                                          // 詳細FDに表示するステータスラベル
      vin: null,                                                                // データ保存画面のVIN/車両番号
      vehicleName: null,                                                        // データ保存画面の車両
      displayProjectID: '',                                                     // データ保存画面のID
      hideRegistrationNumber: true,                                             // データ保存画面の登録番号表示フラグ
      registrationNumber: '',                                                   // データ保存画面の登録番号表示
      functionName: 'individual.individual_diagnosis_function_special_feature', // データ保存画面の機能名
      dataName: '',                                                             // データ保存画面のデータ名
      preDataName: '',                                                          // データ保存画面の保持用データ名
      dataNameSuffix: 0,                                                        // データ保存画面の連番
      memo: '',                                                                 // データ保存画面のメモ
      preMemo: '',                                                              // データ保存画面の保持用メモ
      // ダイアログフラグ
      modal_special_requirement_ES7: false,
      isSession: false,                                                         // セッション遷移の状態監視
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      vehicleModelDisplayNameList: state => state.masterResources.vehicleModelDisplayNameList,
      language: state => state.systems.language,
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
          return 'danger';
        default:
          return 'secondary';
      }
    },

    modalSize() {
      switch (this.phase) {
        case PHASE.DETAILED_FD:
          return 'huge';
        default:
          return 'lg';
      }
    },

    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
    operationScreen() {
      return diagnoseResource.operationFrom(this.$router.currentRoute.value.name);
    },
  },

  components: {
    "custom-table": customTable,
    "project-data": projectData,
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_special_requirement_ES7 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      // リソース(作動履歴_DID)のi18nキー取得
      this.i18nSpwsDidKey = `controlHistory${this.systemId}`;

      // プロジェクト保存画面、詳細FDエクスポート時の登録番号の表示有無を判定
      const vehicle = this.vehicleInfo.vehicle;
      if (vehicle.vin.type === config.VEHICLEINFO_TYPE_VIN) {
        this.hideRegistrationNumber = false;
      }
    },

    /** メモ情報、データ名のクリア */
    clear: function () {
      this.diagnoseComment = '';
      [this.dataName, this.preDataName] = [this.preDataName, this.dataName];
      [this.memo, this.preMemo] = [this.preMemo, this.memo];
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_special_requirement_ES7 = false;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** データ読み出し処理 */
    async read() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        // データ読み出し(要求)（バックエンドAPI_POST）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read',
            is_special: true
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // セッション遷移の状態を更新 取得できない場合はtrueをセットしてexit APIを呼び出すようにしておく
          this.isSession = response.data?.user_data?.is_session ?? true;
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // CCから取得データを参照する為、Sort_KeyにあたるリクエストIDを次のAPIに渡す
              await this.dataFormat(response.data.user_data.request_id);
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        } else {
          // セッション遷移の状態をtrueに更新し、exit APIが実行されるようにしておく
          this.isSession = true;
          this.showUnexpectedError();
        }
      }
      finally {
        this.isLoading = false;
      }
    },

    /** データ整形API実行 */
    async dataFormat(request_id) {
      const token = session.getToken();
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        this.systemId,
        this.workSupportId,
        {
          id_token: token.id_token,
          type: 'format',
          project_id: this.vehicleInfo.vehicle.project.id,
          request_id: request_id,
          is_special: true
        },
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            this.preFdData = response.data.user_data.fd_data_list;
            this.preDetailFdData = response.data.user_data.detail_fd_list;
            // プロジェクトデータ保存画面表示用データ名初期値の設定
            this.preDataName = response.data.user_data.data_name;
            this.dataNameSuffix = parseInt(this.preDataName.substring(4));
            this.createColumns();
            this.createDisplayData();
            break;
          default:
            this.showUnexpectedError();
            break;
        }
      } else {
        this.showUnexpectedError();
      }
    },

    /** Projectデータ保存処理 */
    async save() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'save',
            is_special: true,
            project_id: this.vehicleInfo.vehicle.project.id,
            fd_data_list: this.preFdData,
            detail_fd_list: this.preDetailFdData
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              await this.update(response.data.user_data.measured_id);
              this.dataNameSuffix = this.dataNameSuffix + 1;
              this.dataName = this.$refs.projectData.inputDataName;
              this.preDataName = 'Data' + String(this.dataNameSuffix);
              this.memo = this.$refs.projectData.inputMemo;
              this.preMemo = '';
              break;
            default:
              break;
          }
        }
      }
      finally {
        this.isLoading = false;
        // 画面再描画のために再度以下関数を呼び出す
        await this.backEvent();
      }
    },

    /** Projectデータ更新処理 */
    async update(measuredId) {
      const endPoint = '/projects/' + this.vehicleInfo.vehicle.project.id + '/' + measuredId;
      const reqBody = {
        name: this.vehicleInfo.vehicle.project.id,
        comment: this.$refs.projectData.inputDiagnoseComment,
        measured: {
          name: this.$refs.projectData.inputDataName,
          memo: this.$refs.projectData.inputMemo
        }
      };
      const res = await api.postCall(config.WSP, endPoint, reqBody, this.operationScreen);
      let ret = false;
      // APIレスポンスの検証
      handler.validate(handler.validateTypes.all, res, this, null, () => {
        ret = true;
      }, (result) => {
        // レスポンス不正時のコールバック
        if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
      });
      return ret;
    },

    /** 共通エラー画面OKボタン押下時 Exit API */
    async exit() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: this.isSession ? 'exit' : 'dispose',  // isSession=true の場合は exit API を呼び出し、false の場合は dispose API を呼び出し※セッション状態が不明な場合は安全側の処理として exit API を呼び出す
            is_special: true
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        // 結果に関わらず機能終了
        this.closeWizard();
      }
      finally {
        this.isLoading = false;
      }
    },

    /**
     * 一覧表示画面のTableColumns作成
     * @param {string} response レスポンスデータ
     */
    createColumns() {
      this.tableColumns = [
        { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: this.sortFdDataStatus },
        { name: 'ig_on', label: `individual.label_ws60_ig_on_count`, originalSortFunc: this.sortFdDataItems },
        { name: 'occurrence_date', label: `individual.label_ws60_occurrence_time`, originalSortFunc: this.sortFdDataItems },
        { name: 'od_meter', label: `individual.label_ws60_odometer`, originalSortFunc: this.sortFdDataItems },
        { name: 'ffd', label: 'individual.header_vehicle_system_table_details_fd', useButton: true, originalSortFunc: diagnoseResource.sortFuncFfd },
      ];
    },

    /** 一覧表示画面の表示データ作成 */
    createDisplayData() {
      const setArr = [];
      let noDataFlg = false;

      this.preFdData.forEach((obj) => {
        const setObj = {};
        setObj.status = this.$t(`${this.i18nWsKey}.${obj.status}`);
        setObj.unique_status = obj.status;
        setObj.ig_on = obj.igon_time === 0 ? this.$t(`message.common_hyphen`) : obj.igon_time;
        // FD一覧に表示する発生日時を取得するため、FDのDID変換後の値を表示用の値で返す処理を行う関数を呼び出す。日時の為、i18nDidKeyとハイフンフラグは指定しない
        setObj.occurrence_date = individualWorkSupportUtil.getDisplayFdData(this, '', { data_type: obj.occurrence_date_data_type, value: obj.occurrence_date });
        setObj.od_meter = obj.odmeter === 0 ? this.$t(`message.common_hyphen`) : obj.odmeter;
        setObj.buttonVisible = obj.has_fd;
        // ステータスソート用のNo付与
        setObj.no = obj.no;

        // has_fdがtrueのものが存在しない限り、データ無しフラグを更新し続ける
        if (!noDataFlg) {
          noDataFlg = obj.has_fd;
        }

        setArr.push(setObj);
      });
      if (noDataFlg) {
        // 表示データが存在する場合は一覧表示遷移
        this.phase = PHASE.LIST_VIEW;
        setTimeout(() => {
          this.displayInfo = setArr;
        });
      } else {
        // 表示データが存在しない場合はデータ無し表示遷移
        this.phase = PHASE.NODATA;
      }
    },

    /**
     * 詳細FD表示画面のTableColumns作成
     * @param {string} target_status 選択したステータス
     */
    createFdColumns(target_status) {
      // 項目・単位は固定で設定
      this.tableFdColumns = [
        { name: 'item', label: 'message.header_vehice_ffd_item' },
        { name: 'unit', label: 'message.header_vehice_ffd_unit' }
      ];

      // 初回のオブジェクトを取得(ステータス一致且つデータが入っていることが条件)
      const statData = this.preDetailFdData.find((element) => element.status === target_status);
      const obj = statData.detail_fd_data_list.find((element) => element);
      // read_dataの件数分、'n回'表示のカラムを追加する
      const cntMessage = this.$t('individual.header_vehicle_system_table_cnt');
      for (let i = 0; i < obj.read_data.length; i++) {
        this.tableFdColumns.push({ name: 'count_' + i, label: util.setColums((i + 1), cntMessage, "{0}{1}"), useHtmlBind: true });
      }
    },

    /**
     * 詳細FD表示画面の表示データ作成
     * @param {string} target_status 選択したステータス
     */
    createDisplayFdData(target_status) {
      // 対象ステータスのデータを取得
      const statData = this.preDetailFdData.find((element) => element.status === target_status);
      const setArr = [];
      for (const element of statData.detail_fd_data_list) {
        const obj = {};
        // 画面に表示しないが、初期ソート用にDID値をセット
        obj['did'] = element.did;
        // 項目・単位をセット
        obj['item'] = this.$te(`${this.i18nSpwsDidKey}.${element.did}_1_all`) ? this.$t(`${this.i18nSpwsDidKey}.${element.did}_1_all`) : "";
        obj['unit'] = this.$t(`didUnit.${element.unit_id}`);

        // no でソート
        element.read_data.sort((a, b) => a.no > b.no ? 1 : -1);
        // data_typeがValueの項目(read_data先頭のdata_typeを見て判断)で、1項目の値が全て0の場合はハイフンを表示する
        const allHyphenFlg = element.read_data[0].data_type === 'Value' && element.read_data.every((obj) => Number(obj.value) === 0);
        // read_data をloopし、文言ファイルに一致するキーが存在する場合は対象の文言を、それ以外は値をそのままセット(HEXの場合は0xを付与)
        for (let i = 0; i < element.read_data.length; i++) {
          const keyName = 'count_' + i;
          obj[keyName] = individualWorkSupportUtil.getDisplayFdData(this, element.did, element.read_data[i], this.i18nSpwsDidKey, allHyphenFlg);
        }
        setArr.push(obj);
      }
      setTimeout(() => {
        this.displayFdInfo = setArr;
      });
    },

    /** 一覧表示画面 ステータス項目のソート処理 */
    sortFdDataStatus(param) {
      if (!param.data) {
        return null;
      }
      let itemList = [];
      // 別途付与したno項目(画面非表示)でソートする
      itemList = util.sortItems(param.data, "no", param.sortDir);
      return itemList;
    },

    /** 一覧表示画面 他項目(ステータス・詳細FD以外)のソート処理 */
    sortFdDataItems(param) {
      if (!param.data) {
        return null;
      }
      // 結果リスト
      let itemList = [];
      const hyphenList = [];
      param.data.forEach(element => {
        if (element[param.sortKey] !== '-') {
          itemList.push(element);
        }
        else {
          hyphenList.push(element);
        }
      });
      // 昇順・降順に関わらず、ハイフン表示は最下行に表示する
      itemList = util.sortItems(itemList, param.sortKey, param.sortDir);
      itemList = itemList.concat(hyphenList);
      return itemList;
    },

    /** 一覧表示画面 保存ボタン押下 */
    async saveButtonClickEvent() {
      // プロジェクト保存画面の入力情報初期化
      this.clear();

      const vehicle = this.vehicleInfo.vehicle;
      // プロジェクト保存画面に必要な情報を設定
      this.vin = vehicle.vin.vin;
      this.displayProjectID = vehicle.project.id;

      // 車種情報から表示名称を取得
      const spec = shareVehicle.createModelDisplaySpec(vehicle.vin.type, vehicle.spec);
      this.vehicleName = shareVehicle.createModelDisplayNameCurrentLanguage(this.vehicleInfo, this.vehicleModelDisplayNameList, this.language, '{0} {1}', spec);
      // 海外VINの場合、登録番号は画面から非表示にする
      if (this.hideRegistrationNumber) {
        if (vinInfoUtils.outputRegistrationNumber(vehicle.vin)) {
          this.registrationNumber = vinInfoUtils.createRegistrationNumber(vehicle.vin);
        }
        else {
          this.registrationNumber = "";
        }
      }
      this.phase = PHASE.PROJECT_DATA;
    },

    /** 一覧表示画面 FDボタン押下
     * @param {object} row 選択行データ
     */
    async rowButtonClickEvent(row) {
      this.createFdColumns(row.unique_status);
      this.createDisplayFdData(row.unique_status);
      this.statusLabel = this.$t(`message.header_vehicle_dtc_table_status`) + "：";
      this.statusValue = this.$t(`${this.i18nWsKey}.${row.unique_status}`);
      this.phase = PHASE.DETAILED_FD;
    },

    /** 詳細FD画面のファイルエクスポート */
    async csvExport() {
      try {
        this.isLoading = true;
        await fileExport.detailFdToCsv(this);
      } finally {
        this.isLoading = false;
      }
    },

    /** 詳細FD画面 OKボタン押下 */
    async backEvent() {
      this.createColumns();
      this.createDisplayData();
    },

    /** プロジェクト保存画面 キャンセルボタン押下 */
    async callListView() {
      // プロジェクト保存画面の入力情報初期化
      this.clear();
      // 画面再描画のために再度以下関数を呼び出す
      await this.backEvent();
    },

    /** プロジェクトデータ保存画面 保存ボタン押下 */
    async callSaveEvent() {
      if (this.$refs.projectData.validate()) {
        await this.save();
      }
    },

    /** その他エラー発生時の表示 */
    async showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
    }
  },

  async mounted() {
    this.init();
    // データ読み出し
    this.read();
  },
};